import { Outlet } from 'react-router-dom';
import TopBar from './TopBar';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import MobileShell from './MobileShell';

export default function HomeShell() {
  const { isMobile } = useBreakpoint();
  if (isMobile) return <MobileShell />;
  return (
    <div className="flex flex-col h-screen overflow-hidden" style={{ backgroundColor: 'var(--bg-base)' }}>
      <TopBar showUserMenu />
      <main className="flex-1 min-h-0 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
